import { Row, Col, Button, Table, Nav } from "react-bootstrap";
import useSWR from "swr";
import AuthenticatedWrapper from "../../components/wrapper";
import { fetcher, serverUrl, swrConfig } from "../../helpers/utility";
import { useNavigate } from "react-router-dom";
import variables from "../../styles/utils.module.scss";
import styles from "../../styles/provider.module.scss";
import { useCallback } from "react";
import axios from "axios";
import { format, isToday } from "date-fns";
import { APPROVED, IN_REVIEW } from "../../helpers/constants";

function AdminDashboard({ user }) {
  const navigate = useNavigate();

  if (user?.staffUser === false) {
    window.location.href = "https://www.bplaced.co.uk";
  }

  const { data: adminData } = useSWR(`${serverUrl}/admin/stats`, fetcher, swrConfig);

  return (
    <AuthenticatedWrapper user={user}>
      <div style={{ marginTop: "20px", padding: "0px 15px" }}>
        <Row style={{ marginTop: 15 }}>
          <Col xs={6}>
            <h1 className="h3">Insights</h1>

            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className={styles.statBox}>
                <div className={styles.statBoxNumber}>{adminData?.locationActiveCount || 0}</div>
                <div className={styles.statBoxLabel}>Locations Active</div>
              </div>

              <div className={styles.statBox}>
                <div className={styles.statBoxNumber}>{adminData?.laActiveCount || 0}</div>
                <div className={styles.statBoxLabel}>Local Authorities Active</div>
              </div>

              <div className={styles.statBox}>
                <div className={styles.statBoxNumber}>{adminData?.enquiry30DaysCount || 0}</div>
                <div className={styles.statBoxLabel}>Enquiries (30 days)</div>
              </div>
            </div>
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col xs={6}>
            <h2 className="h3">Links</h2>

            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className={styles.statBox}>
                <i
                  className={`bi bi-building`}
                  style={{
                    fontSize: "36px",
                  }}
                ></i>
                <Nav.Link className={styles.statBoxLabel} href={`#/admin/local-authority`}>
                  Local Authorities
                </Nav.Link>
              </div>

              <div className={styles.statBox}>
                <i
                  className={`bi bi-diagram-3`}
                  style={{
                    fontSize: "36px",
                  }}
                ></i>
                <Nav.Link className={styles.statBoxLabel} href={`#/admin/organisation`}>
                  Organisations
                </Nav.Link>
              </div>

              <div className={styles.statBox}>
                <i
                  className={`bi bi-houses`}
                  style={{
                    fontSize: "36px",
                  }}
                ></i>
                <Nav.Link className={styles.statBoxLabel} href={`#/admin/location`}>
                  Locations
                </Nav.Link>
              </div>

              <div className={styles.statBox}>
                <i
                  className={`bi bi-briefcase`}
                  style={{
                    fontSize: "36px",
                  }}
                ></i>
                <Nav.Link className={styles.statBoxLabel} href={`#/admin/service`}>
                  Services
                </Nav.Link>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </AuthenticatedWrapper>
  );
}

export default AdminDashboard;
